<template>
  <el-dialog title="销量情况" :visible.sync="isVisible" :close-on-click-modal="false" width="700px">
    <el-table border :data="tableData.records" v-loading="loading" :header-cell-style="{ backgroundColor: '#F4F8FB' }">
      <el-table-column label="店铺" prop="storeName" min-width="180" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="销量" prop="salesResult" width="120" align="center"></el-table-column>
    </el-table>
    <div class="footerBox">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="tableData.pageNum"
        :page-sizes="[30, 100, 500, 1000]"
        :page-size="tableData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableData.total"
      ></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'NewProductSalesDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    code: {
      type: String,
      default: '',
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: 'product',
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  data() {
    return {
      loading: false,
      allRecords: [],
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.tableData.pageNum = 1
        this.fetchData()
      }
    },
  },
  methods: {
    fetchData() {
      this.loading = true
      const params = {
        listNo: this.rowData.listNo || '',
        planTime: this.form.planTime || '',
        productCode: this.rowData.productCode || this.code || '',
        storeId: this.rowData.storeId || '',
      }
      this.$q.preSalePlan.newProductSalesDetailList({ params }).then((res) => {
        if (res.success && res.data) {
          const list = Array.isArray(res.data) ? res.data : (res.data.records || [])
          this.allRecords = list.map(item => {
            return {
              ...item,
              storeName: item.storeName || item.stareName || '',
              storeId: item.storeId || item.stareId || '',
            }
          })
          this.updateTableData()
        } else {
          this.allRecords = []
          this.updateTableData()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    updateTableData() {
      const start = (this.tableData.pageNum - 1) * this.tableData.pageSize
      const end = start + this.tableData.pageSize
      this.tableData = {
        ...this.tableData,
        records: this.allRecords.slice(start, end),
        total: this.allRecords.length,
      }
    },
    handleSizeChange(val) {
      this.tableData.pageSize = val
      this.tableData.pageNum = 1
      this.updateTableData()
    },
    handleCurrentChange(val) {
      this.tableData.pageNum = val
      this.updateTableData()
    },
  },
}
</script>

<style lang="stylus" scoped>
.footerBox
  text-align right
  padding-top 10px
</style>
